// import React, { Component, Fragment } from "react"; // Tidio import
import React, { Component, createRef, Fragment } from "react";
import { FooterComponent } from "./Footer/Footer";
import { HeaderComponent } from "./Header/header";
import { Loader } from "./Loader";

interface LayoutProps {
  children: React.ReactNode;
  footerContent?: any;
}

export class Layout extends Component<
  LayoutProps,
  { isMounted: boolean; timeoutId?: NodeJS.Timeout }
> {
  state = {
    isMounted: true,
    timeoutId: null,
  };

  private chatSubmitRef = createRef<HTMLButtonElement>();

  componentDidMount(): void {
    this.setState({ isMounted: true });

    if (typeof window === "undefined" || typeof document === "undefined" || !this.state.isMounted) {
      return;
    }
    // Tidio implementation (commented out)
    /*
    if (document.getElementById("tidio-script")) {
      return;
    }
    (function (d) {
      const h = d.head || d.getElementsByTagName("head")[0];
      const s = d.createElement("script");
      s.setAttribute("type", "text/javascript");
      s.setAttribute("src", "//code.tidio.co/kco4qo2ni9ylqrxuglbistv6vcsvwqfn.js");
      s.setAttribute("async", "true");
      s.setAttribute("id", "tidio-script");
      h.appendChild(s);
    })(document);
    */

    // Collect.chat implementation (active)
    if (document.getElementById("chat-bot-launcher-container")) {
      return;
    }
    (function (w: any, d, chatSubBtn: HTMLButtonElement) {
      if (d.getElementById("chat-bot-launcher-container")) {
        return;
      }
      w.CollectId = "5c0283cd001a8304e04b8070";
      const h = d.head || d.getElementsByTagName("head")[0];
      const s = d.createElement("script");
      s.setAttribute("type", "text/javascript");
      s.setAttribute("src", "https://collectcdn.com/launcher.js");
      s.onload = function (ev) {
        const collectchat = w.collectchat || {};

        collectchat.on("complete", () => {
          chatSubBtn?.click();
        });
      };
      h.appendChild(s);
    })(window, document, this.chatSubmitRef.current);

    // Apollo tracker implementation (similar to Collect.chat)
    if (document.getElementById("apollo-tracker-script")) {
      return;
    }
    (function (w: any, d: any) {
      if (d.getElementById("apollo-tracker-script")) {
        return;
      }
      const h = d.head || d.getElementsByTagName("head")[0];
      const s = d.createElement("script");
      s.setAttribute("type", "text/javascript");
      s.setAttribute("id", "apollo-tracker-script");
      const n = Math.random().toString(36).substring(7);
      s.src = "https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache=" + n;
      s.async = true;
      s.defer = true;
      s.onload = function () {
        if (w.trackingFunctions && typeof w.trackingFunctions.onLoad === "function") {
          w.trackingFunctions.onLoad({ appId: "699826fabe0c350015d11282" });
        }
      };
      h.appendChild(s);
    })(window, document);
  }

  componentWillUnmount(): void {
    this.setState({ isMounted: false });
    clearTimeout(this.state.timeoutId);
  }

  render(): JSX.Element {
    return (
      <Fragment>
        <Loader />
        <HeaderComponent />
        <section className="page">{this.props.children}</section>
        <FooterComponent content={this.props.footerContent} />
        <button style={{ display: "none" }} id="chat-bot-submit" ref={this.chatSubmitRef} />
      </Fragment>
    );
  }
}
